import { TransText } from '@/i18n/trans/text';
import type { PassengerDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { formatPassengerCard, isPrmNeedCode } from '@/utils/passenger';
import { Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface PassengerBookingAttributesProps {
  passenger?: {
    cards?: PassengerDTO['cards'];
    prmNeeds?: PassengerDTO['prmNeeds'];
  } | null;
  passengerType?: string;
  className?: string;
}

const PassengerBookingAttributes: FC<PassengerBookingAttributesProps> = ({
  passenger,
  passengerType,
  className,
}) => {
  const cards = passenger?.cards ?? [];
  const prmNeeds = passenger?.prmNeeds ?? [];
  const cardLines = cards
    .map(formatPassengerCard)
    .filter((line): line is string => Boolean(line));
  if (!passengerType && !cardLines.length && !prmNeeds.length) {
    return null;
  }

  return (
    <div className={cn('mt-1 flex flex-col gap-0.5', className)}>
      {passengerType && (
        <Typography variant="body2" className="text-neutral">
          {passengerType}
        </Typography>
      )}
      {cardLines.map((line, index) => (
        <Typography
          key={`card-${index}`}
          variant="body2"
          className="text-neutral"
        >
          {line}
        </Typography>
      ))}
      {prmNeeds.map((need, index) => (
        <Typography
          key={`prm-${index}`}
          variant="body2"
          className="text-neutral"
        >
          {isPrmNeedCode(need) ? <TransText i18nKey={need} /> : need}
        </Typography>
      ))}
    </div>
  );
};

export default PassengerBookingAttributes;
